import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "procedures-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { class: "io-mfe-ig-dt-col-left-spacer" }, null, -1)
const _hoisted_3 = {
  key: "action",
  class: "io-mfe-ig-dt-col-action"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", {
  class: "pdx",
  key: "slot io-mfe-ig-dt-col-pdx"
}, null, -1)
const _hoisted_5 = {
  key: "modifier",
  class: "io-mfe-ig-dt-col-modifier"
}
const _hoisted_6 = {
  key: "code",
  class: "code io-mfe-ig-dt-col-code"
}
const _hoisted_7 = {
  key: "description",
  class: "text-ellipsis io-mfe-ig-dt-col-desc"
}
const _hoisted_8 = { class: "ellipsis" }

import { QTableProps } from 'quasar';
import DataTable from 'components/grouper-common/DataTable.vue';
import { useGrouperStore } from 'stores/grouper-store';
import { CodeType } from 'src/contracts/codeType';
import { storeToRefs } from 'pinia';
import {ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProceduresPane',
  setup(__props) {

const columns: QTableProps['columns'] = [
  {name: 'left-spacer', align: 'center', label: '', field: 'left-spacer', sortable: false},
  {name: 'action', align: 'center', label: '', field: 'action', sortable: false},
  {name: 'pdx', align: 'center', label: '', field: 'pdx', sortable: false},
  {name: 'modifier', align: 'center', label: 'DRG Modifier', field: 'modifier', sortable: false},
  {name: 'code', align: 'left', label: 'Code', field: 'code', sortable: false},
  {name: 'desc', align: 'left', label: 'Procedure Description', field: 'desc', sortable: false}
]

const { procedureCodes, editsSelectedCode } = storeToRefs(useGrouperStore());

const timer = ref<NodeJS.Timeout>();

watch(editsSelectedCode, () => {
  clearTimeout(timer.value);

  timer.value = setTimeout(() => {
    editsSelectedCode.value = '';
  }, 3000);
});

function rowClasses(index: number, row: any): string {
  const classList = [];

  if(row.code === editsSelectedCode.value) {
    classList.push('highlight-row');
  }

  if (index % 2 === 0) {
    classList.push('iodine-alternate-table-row');
  } else {
    classList.push('bg-white');
    classList.push('text-black');
  }

  return classList.join(' ');
}

function titleText() {
    return `Procedures (${procedureCodes.value?.length || 0})`
}


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DataTable, {
      title: titleText(),
      rows: _unref(procedureCodes),
      columns: columns,
      type: _unref(CodeType).Procedure
    }, {
      "dt-thead": _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
              return _createElementVNode("th", {
                class: _normalizeClass(["ellipsis", (col.headerClasses ? col.headerClasses : '') + ` io-mfe-ig-dt-col-${col.name}`]),
                key: col.name
              }, _toDisplayString(col.label), 3)
            }), 64))
          ])
        ])
      ]),
      "dt-rows": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(procedureCodes), (row, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass(rowClasses(index, row))
          }, [
            _hoisted_2,
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                dense: "",
                flat: "",
                unelevated: "",
                class: "text-none io-mfe-ig-icon-button-small q-btn--round",
                size: "sm",
                icon: "fa-solid fa-ellipsis-vertical"
              })
            ]),
            _hoisted_4,
            _createElementVNode("td", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.drgModifier, (impact, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(impact)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(impact), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(row.code), 1)
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.description), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_8, _toDisplayString(row.description), 1)
            ])
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "rows", "type"])
  ]))
}
}

})